import React, {useEffect, useState} from "react";
import Logo from "../../icons/Logo";
import 'react-tooltip/dist/react-tooltip.css'
import {Tooltip as ReactTooltip} from 'react-tooltip';
import ToolTip from "../../icons/ToolTip";
import Pdf from "../../icons/Pdf";
import Xsel from "../../icons/Xsel";

export default ({packages = [], sample_allowance, name, hideMessage}) => {

  const [currentPackage, setCurrentPackage] = useState(null);

  useEffect(() => {
    if (packages) {
      const activePackage = packages?.find((p) => p.is_active) || null;
      setCurrentPackage(activePackage);
    }
  }, [packages]);

  const darkenColor = (hex, amount) => {
    let color = parseInt(hex, 16);
    let r = Math.max(0, (color >> 16) - amount);
    let g = Math.max(0, ((color >> 8) & 0x00ff) - amount);
    let b = Math.max(0, (color & 0x0000ff) - amount);
    return ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  };


  let isFirstIncluded = packages ? packages.find((a) => a.is_first === true) : false;

  return (
    <div className="loyalty-package">
      {(packages.length > 0 && !hideMessage) && <div className={'typography'}>
        <p>
          Thanks for your business – we appreciate it.
        </p>
        <p>As you spend more with Cloke, you move up status levels, receiving better prices and a larger free sample allowance.</p>
        {sample_allowance?.can_use_samples &&
        <p>
          To use your free sample allowance, tick the ‘Sample Order’ box at checkout on the next page.<br />
          Note, this is restricted to orders of 3 garments or less, max 1 per style.
        </p>
        }
        <p>
          You can review your status at any time by going to Account > Loyalty Status.
        </p>
      </div>}
      <div className="progress-packages">
        {currentPackage &&
        <div className="progress-packages__desc__holder">
          <div
            className="progress-packages__desc"
            style={{
              backgroundColor: `#${currentPackage.progress_bar_color || 'd4d2d2'}`,
              boxShadow: `4px 4px 5px #${darkenColor(
                currentPackage.progress_bar_color || 'd4d2d2',
                40
              )} inset`,
            }}
          >

            <div className="progress-packages__desc__content">
              <h5>{currentPackage.title} Status</h5>
              <p
                dangerouslySetInnerHTML={{
                  __html: currentPackage.description,
                }}
              />
            </div>
            <div className="progress-packages__desc__logo">
              <Logo/>
            </div>
            <div className={'progress-packages__desc__name'}>
              {name}
            </div>
          </div>
        </div>
        }

        {packages.length > 0 && <div className="progress-packages__packageList">
          {packages
            .filter((a) => { return a.is_first !== true; })
            .sort((a, b) => a.sort - b.sort)
            .slice(0, isFirstIncluded ? 1 : 2)
            .map((p, index) => (
              <div key={index} className={`package package--${p.progress_bar_color}`}>
                <h6>{p.title_prefix} {p.title} {p.tooltip && <span id={`tooltip--${index}`}><ToolTip/></span>}</h6>

                <ReactTooltip place="top" type="dark" effect="solid" content={p.tooltip}
                              anchorSelect={`#tooltip--${index}`}/>

                <progress value={p.standard_progress} max={1} className="progress-bar" style={{
                  "--progress-color": `#${p.progress_bar_color}`,
                }}/>
                <div className="package__data">
                  <div className="package__data__spent">
                    <p>{p.spent} spent</p>
                    {p.is_active && p.start_date && <span>Since {p.start_date}</span>}
                  </div>
                  <div className="package__data__needed">
                    <p>{p.needed} needed</p>
                    {p.is_active && p.end_date && <span>by {p.end_date}</span>}
                    {!p.is_active && <span>To advance today</span>}
                  </div>
                </div>
              </div>
            ))}

            <div className="progress-packages__sample">
              {sample_allowance && Object.keys(sample_allowance).length > 0 && (<>
                  <h6>Free Sample allowance</h6>
                  <progress value={sample_allowance.sample_progress} max={1}/>

                  <div className="progress-packages__sample__data">
                    <p>{sample_allowance.spent} spent</p>
                    <p>{sample_allowance.available} available</p>
                  </div>
                </>
              )}
            </div>

        </div>}
      </div>


      {/*{currentPackage &&*/}
      {/*<div className="progress-packages__desc__content">*/}
      {/*  {currentPackage.excel_file_url &&*/}
      {/*  <a href={currentPackage.excel_file_url} className="progress-packages__file" target={'_blank'}>*/}
      {/*    <Pdf />*/}
      {/*    Download {currentPackage.title} Pricelist-Excel*/}
      {/*  </a>}*/}
      {/*  {currentPackage.pdf_file_url &&*/}
      {/*  <a href={currentPackage.pdf_file_url} className="progress-packages__file" target={'_blank'}>*/}
      {/*    <Xsel />*/}
      {/*    Download {currentPackage.title} Pricelist-PDF*/}
      {/*  </a>}*/}
      {/*</div>*/}
      {/*}*/}

    </div>
  );
};
